import { BASE_URL } from "./constants";
import { PaymentMessage } from "./helpers/websocketTypes";
import { getAccessToken } from "../helpers/jwtHelpers";
import { Options } from "react-use-websocket";

function getWebSocketBaseUrl() {
  // https://stage-pwa.wildwildapps.com/api (BASE_URL) => wss://stage-pwa.wildwildapps.com/websocket
  // http://localhost:3000/api => ws://localhost:3000/websocket
  return BASE_URL
    .replace('https://', 'wss://')
    .replace('http://', 'ws://')
    .replace('/api', '/websocket');
}

type WsEventData<T> = {
  event_name: string,
  message: T
};

/// GLOBAL
export const wsOptions: Options = {
  share: true, // share existing connection to WebSocket with same connection URL
  shouldReconnect: () => true,
  reconnectAttempts: 10,
  reconnectInterval: 3000,
};

/// PAYMENT
export const getPaymentWebSocket = () => {
  const token = getAccessToken();
  if (!token) {
    console.warn('No access token available for WebSocket connection');
    return null;
  }
  return getWebSocketBaseUrl() + '/pwa/payment/?token=' + token;
};

export function decodePaymentEvent(event: MessageEvent) {
  const { message } = JSON.parse(event.data) as WsEventData<PaymentMessage>;

  return message;
}